import Usluga from "~/cabinet/ts/data/usluga/Usluga";
import {USLUGA_ID_CALL_GATE} from "~/cabinet/ts/Constant";
import {useRawAsyncComponent} from "~/core-ui/ts/useRawComponent";

const CallGate: Usluga = Usluga.new({
    id: USLUGA_ID_CALL_GATE,
    dealer: {
        config: {
            tarifComponent: useRawAsyncComponent(() => import(/* webpackChunkName: "dealer-callgate" */ '~/cabinet/vue/dealer/config/uslugi/tarif/callGate/CallGateTarifList.vue'))
        }
    },
    client: {
        tarifComponent: useRawAsyncComponent(() => import(/* webpackChunkName: "client-callgate" */ '~/cabinet/vue/client/tarif/CallGateTarifs.vue'))
    }
});

export default CallGate;
